import { JobApplication, JobApplicationStatus } from "../../Entities/job-application.entity";
import { InterviewSession, Question } from "../../Interface/Index";
import InterviewService from "../../Services/interview.service";
import JobApplicationService from "../../Services/job.application.service";

type PollingFunctions = {
  checkForNewSessions: (
    appliedJobId: string,
    interviewSessions: InterviewSession[]
  ) => Promise<InterviewSession[]>;
  checkForNextRoundQuestions: (sessionId: string) => Promise<Question[]>;
    checkApplicationStatus: (
        id: string,
        status: JobApplicationStatus
    ) => Promise<JobApplication>;
};

const usePollingFunctions = (): PollingFunctions => {
  const interviewService = new InterviewService();
  const jobApplicationService = new JobApplicationService();


  const checkForNewSessions = (
    appliedJobId: string,
    interviewSessions: InterviewSession[]
  ): Promise<InterviewSession[]> => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const newSessions = await interviewService.getAllInterviewSessionById(
            appliedJobId
          );

          if (newSessions && newSessions.length > interviewSessions.length) {
            clearInterval(interval);
            resolve(newSessions);
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 2000);
    });
  };

  const checkForNextRoundQuestions = (
    sessionId: string
  ): Promise<Question[]> => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const session = await interviewService.findSessionById(sessionId);
          if (session && session.isQuestionsGenerated) {
            const questions = await interviewService.getQuestionsBySessionId(
              sessionId
            );
            clearInterval(interval);
            resolve(questions);
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 2000);
    });
  };

    const checkApplicationStatus = async (
    id: string,
    status: JobApplicationStatus
  ): Promise<JobApplication> => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const jobApplication =
            await jobApplicationService.findJobApplicationById(id);
          if (jobApplication && jobApplication.status === status) {
            clearInterval(interval);
            resolve(jobApplication);
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 2000);
    });
  };

  return {
    checkForNewSessions,
    checkForNextRoundQuestions,
    checkApplicationStatus,
  };
};

export default usePollingFunctions;
